import get from 'lodash/get';
import WebLayout from '../views/containers/layouts/web_layout/web_layout';
import BlankLayout from '../views/containers/layouts/blank_layout/blank_layout';

import homepageRoute from '../views/containers/pages/home_page/homepage_route';
import allRoute from '../views/containers/pages/home_page/homepage_all_route';
import allIndexRoute from '../views/containers/pages/home_page/homepage_all_index_route';
import authorRoute from '../views/containers/pages/author_page/routes/author_route';
import categoryRoute from '../views/containers/pages/category_page/routes/category_route';
import categoryPaginatedRoute from '../views/containers/pages/category_page/routes/category_paginated_route';
import newsCategoryRoute from '../views/containers/pages/category_page/routes/news_category_route';
import magazineCategoryRoute from '../views/containers/pages/category_page/routes/magazine_category_route';
import htmlSitemapIndexRoute from '../views/containers/pages/html_sitemap_index_page/html_sitemap_index_route';
import htmlSitemapYearRoute from '../views/containers/pages/html_sitemap_index_page/html_sitemap_year_route';
import htmlSitemapPostRoute from '../views/containers/pages/html_sitemap_post_page/html_sitemap_post_route';
import wpPageRoute from '../views/containers/pages/wp_page/routes/wp_page_route';
import applyRoute from '../views/containers/pages/wp_page/routes/apply_route';
import searchRoute from '../views/containers/pages/search_page/routes/search_route';
import tagPageRoute from '../views/containers/pages/tag_page/routes/tag_page_route';
import podcastPageRoute from '../views/containers/pages/podcast_page/routes/podcast_page_route';
import brandworksRoute from '../views/containers/pages/tag_page/routes/brandworks_route';
import thorntonRoute from '../views/containers/pages/tag_page/routes/thornton-route';
import citrixBrandPageRoute from '../views/containers/pages/tag_page/routes/citrix_brand_route';
import livingSmarterTagPageRoute from '../views/containers/pages/tag_page/routes/living_smarter_tag_page_route';
import urbanXTagPageRoute from '../views/containers/pages/tag_page/routes/urban_x_tag_page_route';
import magazineTagPageRoute from '../views/containers/pages/tag_page/routes/magazine_tag_page_route';
import productRoute from '../views/containers/pages/ibd/product_page/product_route';
import productIndexRoute from '../views/containers/pages/ibd/product_index_section_page/routes/product_index_route';

import personIndexRoute from '../views/containers/pages/mcp/person_index_section_page/routes/person_index_route';
import {
  ibd2019Page,
  ibd2018Page,
  legacyIbdPage
} from '../views/containers/pages/ibd/innovation_by_design_page/ibd_route';
import {
  ibd2018CategoryPage,
  legacyIbdCategoryPage
} from '../views/containers/pages/ibd/innovation_by_design_page/ibd_category_route';
import ibdCompanyPage from '../views/containers/pages/ibd/innovation_by_design_page/ibd_company_route';
import mcpCommunity from '../views/containers/pages/mcp/most_creative_people_community_section_page/routes/mcp_community_route';
import {
  mcp2018Page,
  mcp2019Page,
  legacyMcpPage
} from '../views/containers/pages/mcp/most_creative_people_page/most_creative_people_route';
import companyRoute from '../views/containers/pages/mic/company_page/company_route';
import companyIndexRoute from '../views/containers/pages/mic/company_index_section_page/routes/company_index_route';
import {
  micPage2018,
  micPage2019,
  micPage2020,
  legacyMicPage
} from '../views/containers/pages/mic/mic_year_page/routes/mic_year_route';
import personRoute from '../views/containers/pages/mcp/person_page/person_route';
import postRoute from '../views/containers/pages/post_page/routes/post_route';
import bestWorkplacesRoute from '../views/containers/pages/post_page/routes/best_workplaces_route';
import mostCreativePeoplePostRoute from '../views/containers/pages/post_page/routes/most_creative_people_route';
import innovationByDesignPostRoute from '../views/containers/pages/post_page/routes/innovation_by_design_post_route';
import postSectionRoute from '../views/containers/pages/post_page/routes/post_section_route';
import postPaginatedSlideshowRoute from '../views/containers/pages/post_page/routes/post_paginated_slideshow_route';
import postPreviewRoute from '../views/containers/pages/post_page/routes/post_preview_route';
import postPreviewSectionRoute from '../views/containers/pages/post_page/routes/post_preview_section_route';
import notFoundRoute from '../views/containers/pages/not_found_page/not_found_route';
import videoRoute from '../views/containers/pages/video/video_page/video_route';
import playlistIndexRoute from '../views/containers/pages/video/playlist_index_page/video_playlist_index_route';
import videoIndexRoute from '../views/containers/pages/video/video_index_page/video_index_route';
import playlistRoute from '../views/containers/pages/video/playlist_page/video_playlist_page_route';
import newslettersRoute from '../views/containers/pages/newsletters/newsletters_page/newsletters_route';
import newsletterPreferencesRoute from '../views/containers/pages/newsletters/newsletters_preferences/newsletters_preferences_page_route';
import categoryTagRoutes from '../views/containers/pages/category_page/routes/category_tag_route';

import giftGuideRoute from '../views/containers/pages/gift_guide/gift_guide_page/gift_guide_route';
import giftGuideCategoryRoute from '../views/containers/pages/gift_guide/gift_guide_page/gift_guide_category_route';
import giftRoute from '../views/containers/pages/gift_guide/gift_page/gift_route';

export default function getRoutesWithStore(store) {
  const state = store.getState();
  const isBlank = get(state, 'isBlank');
  const featureFlags = get(state, 'config.featureFlags', {});
  const routeConfig = [
    {
      component: isBlank ? BlankLayout : WebLayout,
      routes: [
        newsletterPreferencesRoute(store),
        videoRoute(store),
        videoIndexRoute(store),
        playlistIndexRoute(store),
        playlistRoute(store),
        allIndexRoute(store),
        allRoute(store),
        wpPageRoute(store),
        applyRoute(store),
        newslettersRoute(store),
        searchRoute(store),
        htmlSitemapIndexRoute(store),
        htmlSitemapYearRoute(store),
        htmlSitemapPostRoute(store),
        livingSmarterTagPageRoute(store),
        urbanXTagPageRoute(store),
        tagPageRoute(store),
        podcastPageRoute(store),
        brandworksRoute(store),
        thorntonRoute(store),
        citrixBrandPageRoute(store),
        ...magazineTagPageRoute(store),
        productIndexRoute(store),
        productRoute(store),
        innovationByDesignPostRoute(store),
        ibdCompanyPage(store),
        ibd2018CategoryPage(store),
        ibd2019Page(store),
        legacyIbdCategoryPage(store),
        ibd2018Page(store),
        legacyIbdPage(store),
        giftGuideRoute(store),
        giftGuideCategoryRoute(store),
        giftRoute(store),
        personRoute(store),
        personIndexRoute(store),
        mcpCommunity(store),
        personRoute(store),
        mostCreativePeoplePostRoute(store),
        mcp2018Page(store),
        mcp2019Page(store),
        legacyMcpPage(store),
        companyRoute(store),
        companyIndexRoute(store),
        micPage2019(store),
        micPage2018(store),
        legacyMicPage(store),
        authorRoute(store),
        postPreviewRoute(store),
        postPreviewSectionRoute(store),
        magazineCategoryRoute(store),
        newsCategoryRoute(store),
        categoryPaginatedRoute(store),
        categoryRoute(store),
        ...categoryTagRoutes(store),
        bestWorkplacesRoute(store),
        postRoute(store),
        // bestWorkplacesRoute(store),
        postSectionRoute(store),
        postPaginatedSlideshowRoute(store),
        homepageRoute(store),
        notFoundRoute(store)
      ]
    }
  ];

  if (featureFlags.mic2020) {
    routeConfig[0].routes.unshift(micPage2020(store));
  }

  return routeConfig;
}
